import React from "react";
import { CameraPlaybackScreen } from "./CameraPlaybackScreen";

const CloudStorageScreen = (props: any) => {
  return <CameraPlaybackScreen {...props} mode="cloud-storage" psn="none" />;
};

export default CloudStorageScreen;
